/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import BaseResponse from '../model/BaseResponse';
import PartnerControllerDtoPartnerAccountCheckRequest from '../model/PartnerControllerDtoPartnerAccountCheckRequest';
import PartnerControllerDtoPartnerAccountCheckResponse from '../model/PartnerControllerDtoPartnerAccountCheckResponse';
import PartnerControllerDtoPartnerAccountCreateRequest from '../model/PartnerControllerDtoPartnerAccountCreateRequest';
import PartnerControllerDtoPartnerAccountDetailRequest from '../model/PartnerControllerDtoPartnerAccountDetailRequest';
import PartnerControllerDtoPartnerAccountDetailResponse from '../model/PartnerControllerDtoPartnerAccountDetailResponse';
import PartnerControllerDtoPartnerAccountListRequest from '../model/PartnerControllerDtoPartnerAccountListRequest';
import PartnerControllerDtoPartnerAccountListResponse from '../model/PartnerControllerDtoPartnerAccountListResponse';
import PartnerControllerDtoPartnerAccountRemoveRequest from '../model/PartnerControllerDtoPartnerAccountRemoveRequest';
import PartnerControllerDtoPartnerAccountRemoveResponse from '../model/PartnerControllerDtoPartnerAccountRemoveResponse';

/**
* PerplayPartner service.
* @module api/PerplayPartnerApi
* @version 1.0
*/
export default class PerplayPartnerApi {

    /**
    * Constructs a new PerplayPartnerApi. 
    * @alias module:api/PerplayPartnerApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiPerplayPartnerPartnerAccountCheckPost operation.
     * @callback module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountCheckPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartnerControllerDtoPartnerAccountCheckResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartnerControllerDtoPartnerAccountCheckRequest} [partnerControllerDtoPartnerAccountCheckRequest] 
     * @param {module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountCheckPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartnerControllerDtoPartnerAccountCheckResponse}
     */
    apiPerplayPartnerPartnerAccountCheckPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['partnerControllerDtoPartnerAccountCheckRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PartnerControllerDtoPartnerAccountCheckResponse;
      return this.apiClient.callApi(
        '/api/PerplayPartner/PartnerAccountCheck', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayPartnerPartnerAccountCreatePost operation.
     * @callback module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountCreatePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/BaseResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartnerControllerDtoPartnerAccountCreateRequest} [partnerControllerDtoPartnerAccountCreateRequest] 
     * @param {module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountCreatePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/BaseResponse}
     */
    apiPerplayPartnerPartnerAccountCreatePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['partnerControllerDtoPartnerAccountCreateRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = BaseResponse;
      return this.apiClient.callApi(
        '/api/PerplayPartner/PartnerAccountCreate', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayPartnerPartnerAccountDetailPost operation.
     * @callback module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountDetailPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartnerControllerDtoPartnerAccountDetailResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartnerControllerDtoPartnerAccountDetailRequest} [partnerControllerDtoPartnerAccountDetailRequest] 
     * @param {module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountDetailPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartnerControllerDtoPartnerAccountDetailResponse}
     */
    apiPerplayPartnerPartnerAccountDetailPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['partnerControllerDtoPartnerAccountDetailRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PartnerControllerDtoPartnerAccountDetailResponse;
      return this.apiClient.callApi(
        '/api/PerplayPartner/PartnerAccountDetail', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayPartnerPartnerAccountListPost operation.
     * @callback module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountListPostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartnerControllerDtoPartnerAccountListResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartnerControllerDtoPartnerAccountListRequest} [partnerControllerDtoPartnerAccountListRequest] 
     * @param {module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountListPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartnerControllerDtoPartnerAccountListResponse}
     */
    apiPerplayPartnerPartnerAccountListPost(opts, callback) {
      opts = opts || {};
      let postBody = opts['partnerControllerDtoPartnerAccountListRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PartnerControllerDtoPartnerAccountListResponse;
      return this.apiClient.callApi(
        '/api/PerplayPartner/PartnerAccountList', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiPerplayPartnerPartnerAccountRemovePost operation.
     * @callback module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountRemovePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/PartnerControllerDtoPartnerAccountRemoveResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/PartnerControllerDtoPartnerAccountRemoveRequest} [partnerControllerDtoPartnerAccountRemoveRequest] 
     * @param {module:api/PerplayPartnerApi~apiPerplayPartnerPartnerAccountRemovePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/PartnerControllerDtoPartnerAccountRemoveResponse}
     */
    apiPerplayPartnerPartnerAccountRemovePost(opts, callback) {
      opts = opts || {};
      let postBody = opts['partnerControllerDtoPartnerAccountRemoveRequest'];

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = ['application/json', 'text/json', 'application/*+json'];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = PartnerControllerDtoPartnerAccountRemoveResponse;
      return this.apiClient.callApi(
        '/api/PerplayPartner/PartnerAccountRemove', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
